import de from './de.json'
import en from './en.json'
import es from './es.json'
import it from './it.json'
import fr from './fr.json'
import pt from './pt.json'
import ca from './ca.json'

export default {
  es,
  en,
  de,
  it,
  fr,
  pt,
  ca,
}
